import React, {useContext, useState, useEffect, useCallback} from "react";
import arrow from "../../../../../assets/images/arrow_right_white.svg";
import crossWhite from "../../../../../assets/images/cross_keyList_white.svg";
import { Context } from "../../../../../store";
import useHandleNFT from "../../../../../hooks/blockchain/useHandleNFT";
import { formatterUS } from "../../../../../utils";
import useWindowDimensions from "hooks/useWidowDimensions";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const KeyItem = ({ token, onDeleteItem, onAddItem, index, delI, updateTotalAmount, burnSmarter, boostKeys }) => {
  const [{ theme }] = useContext(Context);
  const [amountUpgradeKey, setAmountUpgradeKey] = useState(0);
  const [upgradeLevel, setUpgradeLevel] = useState(token.level + 1)
  const handleNFT = useHandleNFT();
  const windowParams = useWindowDimensions();
  const isMobile = windowParams?.width <= 750;

  useEffect(() => {
    const handler = setTimeout(() => {
      if (!token) {
        return
      }

      token.upgradeLevel = upgradeLevel;

      if (upgradeLevel === token.level + 1 && token.ready) {
        handleNFT
          .getAmountUpgradeKeys([token.tokenId], burnSmarter)
          .then((res) => {
            setAmountUpgradeKey(res)
            if (burnSmarter) {
              token.keyUpgradeAmount = res[0];
            } else {
              token.tresrUpgradeCost = res[0];
            }
            updateTotalAmount()
          });
      } else {
        handleNFT
          .getAmountBoostKeys([token.tokenId], [upgradeLevel], burnSmarter)
          .then((res) => {
            setAmountUpgradeKey(res)
            if (burnSmarter) {
              token.keyUpgradeAmount = res;
            } else {
              token.tresrUpgradeCost = res;
            }
            updateTotalAmount()
          });
      }
    }, 100)
    return () => {
      clearTimeout(handler);
    };
  }, [token, upgradeLevel, updateTotalAmount])


  const boost = !token.ready || upgradeLevel > token.level + 1
  if (token?.flag)
    return (
      <div className={`upgradeAllKeysModal__list--item `}>
        <div className="upgradeAllKeysModal__wrapper">
          <img
            width={56}
            height={56}
            src={token?.image}
            alt=""
            className="upgradeAllKeysModal__image"
          />
          <div className="upgradeAllKeysModal__name--wrapper">
            <span className="upgradeAllKeysModal__name">
              Treasure Key #{token?.tokenId}
            </span>
            <div className="upgradeAllKeysModal__level">
              <span>Level {token?.level}</span>
              <img width={14} height={9} src={arrow} alt="to" />
              <span>Level {upgradeLevel}</span>
            </div>
            {boostKeys &&
            <div>
              <Slider min={token.level + 1} max={150} onChange={(val) => setUpgradeLevel(val)} />
            </div>
            }
            {isMobile && (
              <span className="modal__text text-[16px] mt-1 text-[var(--currencyInputLabel)]">
                {formatterUS(amountUpgradeKey)} {burnSmarter ? 'SMRTR' : 'TRESR'} {boost ? '[BOOST]' : ''}
              </span>
            )}
          </div>
        </div>
        <div className="upgradeAllKeysModal__wrapperRight">
          <img
            src={crossWhite}
            alt={"delete"}
            className="cursor-pointer"
            onClick={() => onDeleteItem(token?.tokenId)}
          />
          {!isMobile && <span>{formatterUS(amountUpgradeKey)} {burnSmarter ? 'SMRTR' : 'TRESR'}  {boost ? '[BOOST]' : ''}</span>}
        </div>
      </div>
    );
  else
    return (
      <div className="upgradeAllKeysModal__list--item">
        <div className="upgradeAllKeysModal__wrapper filter brightness-[0.4]">
          <img
            width={56}
            height={56}
            src={token?.image}
            alt=""
            className="upgradeAllKeysModal__image"
          />
          <div className="upgradeAllKeysModal__name--wrapper">
            <span className="upgradeAllKeysModal__name">
              Treasure Key #{token?.tokenId}
            </span>
            <div className="upgradeAllKeysModal__level">
              <span>Current Level {token?.level}</span>
            </div>
            {isMobile && (
              <span className=" modal__text text-[16px] mt-1 text-[var(--currencyInputLabel)]">
                {formatterUS(amountUpgradeKey)} {burnSmarter ? 'SMRTR' : 'TRESR'}
              </span>
            )}
          </div>
        </div>
        <div className="upgradeAllKeysModal__wrapperRight">
          <div
            className="cursor-pointer text-gray-400 hover:text-white"
            onClick={() => onAddItem(token?.tokenId)}
          >
            Add
          </div>
          {!isMobile && (
            <span className="filter brightness-[0.4]">
              {formatterUS(amountUpgradeKey)} {burnSmarter ? 'SMRTR' : 'TRESR'}
            </span>
          )}
        </div>
      </div>
    );
};

export default KeyItem;
